<template>
  <v-row class="v-col-12 pa-0 ma-0 mt-10 content-container">
    <v-col
      v-if="$route.name && $route.name.startsWith('imprint')"
      cols="12 pa-0"
      ><div
        class="collapsable"
        v-html="
          sanitize($rttI18n.tenantSpecificContent('imprint.content'), {
            ADD_ATTR: ['target']
          })
        "
    /></v-col>
    <v-col
      v-if="$route.name && $route.name.startsWith('privacy')"
      cols="12 pa-0"
      ><div
        class="collapsable"
        v-html="
          sanitize($rttI18n.tenantSpecificContent('privacy.content'), {
            ADD_ATTR: ['target']
          })
        "
    /></v-col>
    <v-col
      v-if="$route.name && $route.name.startsWith('contact')"
      cols="12 pa-0"
      ><div
        class="collapsable"
        v-html="
          sanitize($rttI18n.tenantSpecificContent('contact.content'), {
            ADD_ATTR: ['target']
          })
        "
    /></v-col>
    <v-col
      v-if="$route.name && $route.name.startsWith('accessibility')"
      cols="12 pa-0"
      ><div
        class="collapsable"
        v-html="
          sanitize($rttI18n.tenantSpecificContent('accessibility.content'), {
            ADD_ATTR: ['target']
          })
        "
    /></v-col>
  </v-row>
</template>

<script>
import DOMPurify from 'dompurify';

export default {
  name: 'LegalContainer',
  methods: {
    sanitize: DOMPurify.sanitize
  }
};
</script>

<style scoped>
:deep(h1) {
  margin-bottom: 0.5em;
}
:deep(ol) {
  margin-bottom: 1em;
}
</style>
